<template>
  <v-container fluid fill-height class="align-center justify-center ma-0 pa-0" style="background-color: #95C72B">
    <img src="../../public/assets/logo.png" height="10%" contain style="position: absolute; left: 0; top: 0;margin: 30px;"></img>
    <v-layout class="align-center justify-center">
      <v-flex column class="lg8">
        <v-flex row class="align-center justify-center mt-3">
          <h1 class="fieldName">Username</h1>
          <v-text-field
            class="textfields_style my-3"
            background-color="#edf3ea"
            label="Enter Username"
            solo
            hide-details
            append-icon="person"
            v-model="tf_signup_username"
            autocomplete="off"
          />
        </v-flex>
        <v-flex row class="align-center justify-center mt-3">
          <h1 class="fieldName">Email</h1>
          <v-text-field class="textfields_style my-3"
                        background-color="#edf3ea"
                        label="Enter Email"
                        solo
                        hide-details
                        append-icon="phone"
                        v-model="tf_signup_email"
                        autocomplete="off"
          />
        </v-flex>
        <v-flex row class="align-center justify-center mt-3">
          <h1 class="fieldName">Password</h1>
          <v-text-field class="textfields_style my-3"
                        background-color="#edf3ea"
                        label="Password"
                        solo
                        hide-details
                        append-icon="map"
                        type="password"
                        autocomplete="off"
                        v-model="tf_signup_password"
          />
        </v-flex>
        <v-flex row class="align-center justify-end mt-3">
          <h1 class="fieldName px-1">Confirm Password</h1>
          <v-text-field class="textfields_style my-3"
                        background-color="#edf3ea"
                        label="Confirm Password"
                        solo
                        hide-details
                        append-icon="group"
                        type="password"
                        autocomplete="off"
                        v-model="tf_signup_confirm_password"
          />
        </v-flex>
        <transition duration="10000" v-if="signup_tf_error">
          <v-slide-y-transition>
            <div class="pa-2 red mx-3 signup-error-statement">
              {{this.signup_error_string}}
            </div>
          </v-slide-y-transition>
        </transition>
        <v-layout row class=" mt-5 align-center justify-center">
          <v-btn
            class="AddNewUser align-center justify-center mx-5"
            color="white"
            style="color: #95C72B; border: 1px solid #8de867; font-size: 16px; font-weight: bold"
            large
            @click="loginToDashboard()"
          >
            SIGN UP
          </v-btn>
          <v-btn
            class="AddNewUser align-center justify-center"
            color="white"
            style="color: #95C72B; border: 1px solid #8de867; font-size: 16px; font-weight: bold"
            large
            @click="$router.push({name: 'Login'})"
          >
            Have an Account!
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "SignUp",
  data: () =>{
    return {
      tf_signup_username:"",
      tf_signup_email:"",
      tf_signup_confirm_password:"",
      tf_signup_password:"",
      signup_tf_error: false,
      signup_error_string: "",

    }
  },
  methods:{
    loginToDashboard(){
      this.signup_tf_error = false;
      if(this.tf_signup_username == "" && this.tf_signup_email == "" && this.tf_signup_password == ""
        && this.tf_signup_confirm_password == "")
      {
        this.signup_tf_error = true;
        this.signup_error_string = "Please fill all the fields."
      }
      else if(this.tf_signup_username == ""){
        this.signup_tf_error = true;
        this.signup_error_string = "Username cannot be empty."
      }
      else if(this.tf_signup_email == "")
      {
        this.signup_tf_error = true;
        this.signup_error_string = "Email cannot be empty."
      }
      else if(this.tf_signup_password == ""){
        this.signup_tf_error = true;
        this.signup_error_string = "Password cannot be empty."
      }
      else if (this.tf_signup_confirm_password == ""){
        this.signup_tf_error = true;
        this.signup_error_string = "Confirm password cannot be empty."
      }
      else if(this.tf_signup_password.length < 7){
        this.signup_tf_error = true;
        this.signup_error_string = "Password cannot be less than 7 characters."
      }
      else
      {
        if(this.tf_signup_email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) == null) {
          this.signup_tf_error = true;
          this.signup_error_string = "Please enter a valid email address";
          return;
        }
        if(this.tf_signup_password != this.tf_signup_confirm_password){
          this.signup_tf_error = true;
          this.signup_error_string = "Password and Confirm Password do not match."
          return;
        }
        var signupURL = this.$hostname+"/api/user/signupuser"
        var signupData = new FormData();
        signupData.append("Email",this.tf_signup_email)
        signupData.append("Password",this.tf_signup_password)
        signupData.append("Name",this.tf_signup_username)
        axios
          .post(signupURL,signupData)
          .then((response) => {
            if (response.data.state == "Success") {
              this.$router.push({name: "Login"})
              //console.log(response.data.message)
            }
            else{
              this.signup_tf_error = true;
              this.signup_error_string = response.data.message;
             //console.log(response.data.message)
            }
            //console.log(response)
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
          });
      }
    }
  },
}
</script>


<style>
.fieldName{
  font-size: 18px;
  color: white;
  width: 20%;
}

.AddNewUser{
  border-radius: 20px;
}

.v-text-field--solo.textfields_style, .v-input__slot.textfields_style{
  border: 1px solid #8de867 !important;
  background-color: #8de867 !important;
  border-radius: 5px !important;
}

.accountExists{
  text-decoration: underline;
  font-size: 16px ;
}

.signup-error-statement{
  border-radius: 4px;
  font-size: 14px;
  font-family: Helvetica;
  color: white;
}

</style>





// WEBPACK FOOTER //
// src/UserViews/SignUp.vue